var _rect, _rect2, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymayaLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7942_21756)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7942_21756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7942_21756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0371 17.9998C19.8827 17.9998 18.7081 18.4859 17.9588 19.2554L18.3841 20.106L18.2044 20.2498C17.4097 18.8797 15.9524 17.9998 14.3946 17.9998C11.9644 17.9998 10 20.1263 10 22.6172V27.9838C10 28.1863 10.1418 28.3281 10.3443 28.3281H12.1061C12.2884 28.3281 12.4302 28.1863 12.4302 28.0041V22.5766C12.4302 21.3413 13.1794 20.3288 14.4553 20.3288C15.6501 20.3288 16.5007 21.2198 16.5007 22.5362V26.9915C16.5007 27.194 16.6425 27.3358 16.8247 27.3358H18.5056C18.7081 27.3358 18.8296 27.1737 18.8296 26.9915V22.5362C18.8296 21.2198 19.7207 20.3288 20.9155 20.3288C22.1914 20.3288 22.9002 21.3413 22.9002 22.5766V28.0041C22.9002 28.1661 23.0419 28.3281 23.2445 28.3281H24.9861C25.2088 28.3281 25.3304 28.1661 25.3304 27.9838V22.6172C25.3304 20.1263 23.447 17.9998 21.0371 17.9998Z",
    fill: "#00B464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7954 18.2025H35.1955C35.0132 18.2025 34.8513 18.3241 34.8513 18.5266V18.7493L35.4183 19.6404L35.265 19.7936C34.33 18.7314 32.9928 18 31.4692 18C28.5935 18 26.2241 20.3492 26.2241 23.2857C26.2241 26.1816 28.5935 28.5308 31.4692 28.5308C33.0045 28.5308 34.3507 27.8049 35.2868 26.7423L35.4183 26.8499L34.8513 27.7815V27.984C34.8513 28.1865 35.0132 28.3282 35.1955 28.3282H36.7954C36.9979 28.3282 37.1397 28.1865 37.1397 27.984V18.5266C37.1397 18.3241 36.9979 18.2025 36.7954 18.2025ZM31.4692 26.2626C29.7276 26.2626 28.5125 25.0273 28.5125 23.2857C28.5125 21.5238 29.7276 20.2682 31.4692 20.2682C33.2311 20.2682 34.4868 21.5238 34.4868 23.2857C34.4868 25.0273 33.2311 26.2626 31.4692 26.2626Z",
    fill: "#00B464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.656 18.2025H58.0561C57.8738 18.2025 57.7118 18.3241 57.7118 18.5266V18.7493L58.2789 19.6404L58.1256 19.7936C57.1906 18.7314 55.8534 18 54.3298 18C51.4541 18 49.0847 20.3492 49.0847 23.2857C49.0847 26.1816 51.4541 28.5308 54.3298 28.5308C55.8651 28.5308 57.2113 27.8049 58.1473 26.7423L58.2789 26.8499L57.7118 27.7815V27.984C57.7118 28.1865 57.8738 28.3282 58.0561 28.3282H59.656C59.8585 28.3282 60.0002 28.1865 60.0002 27.984V18.5266C60.0002 18.3241 59.8585 18.2025 59.656 18.2025ZM54.3298 26.2626C52.5882 26.2626 51.3731 25.0273 51.3731 23.2857C51.3731 21.5238 52.5882 20.2682 54.3298 20.2682C56.0917 20.2682 57.3473 21.5238 57.3473 23.2857C57.3473 25.0273 56.0917 26.2626 54.3298 26.2626Z",
    fill: "#00B464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7534 18.2024H46.1131C45.8498 18.2024 45.708 18.3441 45.708 18.4859V23.4273C45.708 24.9664 44.6954 26.0397 43.1361 26.0397C41.6983 26.0397 40.7667 24.9664 40.7667 23.4273V18.4859C40.7667 18.3441 40.5439 18.2024 40.4021 18.2024H38.6403C38.4985 18.2024 38.3567 18.3441 38.3567 18.4859V23.407C38.3567 26.0397 40.4223 28.3281 43.1361 28.3281C44.4009 28.3281 45.5763 27.8547 46.4675 27.0715L46.5586 27.1535L45.8295 28.1459V28.5306C45.8295 29.5432 44.3107 30.1102 43.4196 30.1102H42.8526C42.6501 30.1102 42.488 30.252 42.488 30.4343V32.0544C42.488 32.2164 42.6501 32.3784 42.8526 32.3784H43.4196C46.1333 32.3784 48.118 30.7988 48.118 27.8218V18.4859C48.118 18.3441 47.9762 18.2024 47.7534 18.2024Z",
    fill: "#00B464"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 49,
    rx: 2.5,
    stroke: "#E6E7E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7942_21756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymayaLogo);
export default __webpack_public_path__ + "static/media/paymaya-logo.f3e9220d5f15d1131200a613026a1d6d.svg";
export { ForwardRef as ReactComponent };